import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@albert-io/atomic';
import useMandarkQueries from 'lib/hooks/useMandarkQueries';
import masquerateStore from 'client/generic/Masquerade/Masquerade.store';

import PeopleContext from './people.context';
import SideNav from './SideNav/SideNav.react';
import {
  getClassroomQuery,
  getInvitationsQuery,
  getStudentsQuery,
  getCoteachersQuery
} from './people.queries';

const People = ({params, children}) => {
  const {classId} = params;
  const currentTeacherId = masquerateStore.getUserIdByMasqueradeState();
  const queries = useMemo(
    () => ({
      classroom: getClassroomQuery(classId),
      invitations: getInvitationsQuery(classId),
      students: getStudentsQuery(classId),
      coteachers: getCoteachersQuery(classId)
    }),
    [classId]
  );
  const {
    isReady,
    resources: [classroom, invitations, students, teachers]
  } = useMandarkQueries(Object.values(queries));
  const contextValue = useMemo(() => {
    return {
      isReady,
      classroom,
      invitations,
      students,
      teachers,
      queries,
      currentTeacherId
    };
  }, [isReady, classroom, invitations, students, teachers, queries, currentTeacherId]);
  return (
    <PeopleContext.Provider value={contextValue}>
      <Grid.Container colGap={{all: 8, m: 2}}>
        <Grid.Row>
          <Grid.Col all={3} m={12}>
            <SideNav />
          </Grid.Col>
          <Grid.Col all={9} m={12} className='u-mar-b_4'>
            {React.cloneElement(children)}
          </Grid.Col>
        </Grid.Row>
      </Grid.Container>
    </PeopleContext.Provider>
  );
};

People.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }),
  params: PropTypes.shape({
    classId: PropTypes.string
  }),
  children: PropTypes.node
};

export default People;
